<template>
    <v-card>
        <v-progress-linear
        v-if="loader"
        :active="loader"
        color="blue"
        :indeterminate="true"
        class="ma-0"
        height="5"
        ></v-progress-linear>
        <v-layout row wrap class="pt-3">
            <template v-if="bookings.length">
                <v-flex xs12 v-for="booking,index in bookings" :key="index" class="px-3 pb-3">
                    <v-layout row wrap justify-center align-center>
                        <v-flex xs12 class="border-round">
                            <v-layout row wrap>
                                <v-flex xs12 md9 class="px-3 py-2">
                                    <h2 class="primary--text mb-1">{{booking.screener_title}}</h2>
                                    <div class="title secondary--text text--darken-2  pb-3">{{moment.utc(booking.screener_start_date).local().format("lll") }}</div>
                                    <div class="subheading">
                                        <div ><span class="secondary--text text--darken-2">{{$t('screener.amount_paid.label')}}    : </span>&nbsp;<span class="title secondary--text">{{ booking.currency?getCurrencySymbol(booking.currency):'' }}{{booking.amount}}</span></div>
                                        <div ><span class="secondary--text text--darken-2">{{$t("screener.seats.title")}}</span><span class="secondary--text">{{_seatLabels(booking.seat_labels)}}</span></div>
                                        <div ><span class="secondary--text text--darken-2">{{$t("venue.title")}} : </span><span class="secondary--text">{{ _venue(booking.venue) }}</span></div>
                                        <div>
                                            <span class="secondary--text text--darken-2">{{$t('screener.status.label')}} : </span>
                                            <v-chip small dark outline class="mx-0 pa-0" color="secondary">{{ $t(DEFINES.BOOKING_STATUS_STR[booking.status]) }}</v-chip>
                                        </div>
                                    </div>
                                </v-flex>
                                <v-divider vertical></v-divider>
                                <v-flex xs12 md2 class="px-3 py-2 text-xs-center text-sm-center text-md-right">
                                    <vue-qrcode :value="booking.code" :options="{ width: 140 }"></vue-qrcode>
                                </v-flex>
                            </v-layout>
                            <v-divider></v-divider>
                            <v-layout row wrap >
                                <v-flex xs12 md12 class="px-3 py-1 text-xs-center text-sm-center text-md-right">
                                    <template v-for="(action, index) in actions">
                                        <v-btn v-if="action.isVisible(booking)" class="py-0 primary primary--text" small outline :key="index" :color="action.color"  @click="action.handler(booking)">{{ action.label }}</v-btn>
                                    </template>
                                </v-flex>
                            </v-layout>
                        </v-flex>
                    </v-layout>
                </v-flex>
             </template>
             <template v-else>
                 <v-flex xs12 class="text-xs-center pa-5">
                    <div class="secondary--text">
                        <div class="title">
                           {{$t("screener.ticket_bookings.no_tickets.title")}}
                        </div>
                        <div class="subheading pt-1">
                            {{$t("screener.ticket_bookings.no_tickets.subtitle")}}
                        </div>
                    </div>
                 </v-flex>
             </template>
        </v-layout>
        <BookingSupport
        :dialog="bookingSupportDialog"
        :query.sync="query"
        :eventTitle="booking.screener_title"
        @onConfirm="submitBookingQuery"
        @reset="resetBookingSupportDialog"
        ></BookingSupport>
        <RefundModification
        :dialog="refundModificationDialog"
        :eventTitle="booking.screener_title"
        :booking_id="booking.id"
        :screener_id="booking.screener_id"
        @reset="resetRequestFormParam"
        ></RefundModification>
        <TicketsDialog  :ticket_dialog.sync="ticket_dialog" :booking="booking"></TicketsDialog>
    </v-card>
</template>

<script>
import BookingSupport from "@/components/dialogBox/BookingSupport"
import RefundModification from "@/components/dialogBox/RefundModification";
import TicketsDialog from "@/components/consumer/TicketsDialog"
import { mapGetters } from "vuex";

import VueQrcode from '@chenfengyuan/vue-qrcode';
import { currencySymbol } from "@/mixins/currencySymbol";

export default {
    name:"ConsumerTicketBookings",
    data(){
        return{
            bookings:[],
            loader:false,
            actions: [
                {
                    isVisible:(booking)=>true,
                    label: this.$t("screener.btn.download_ticket"),
                    color:"",
                    handler:this.previewTickets,
                },
                {
                    isVisible:(booking)=>booking.purchase_receipt_url,
                    label: this.$t("screener.btn.download_receipt"),
                    color:"",
                    handler:this.viewReceipt
                },
                {
                    isVisible:(booking)=>true,
                    label: this.$t("screener.support"),
                    color:"primary",
                    handler:this.showBookingSupportDialog
                },
                {
                    isVisible:(booking)=>booking.purchase_receipt_url,
                    label: this.$t("booking.refund.request.button"),
                    color:"primary",
                    handler:this.showRefundRequestDialog
                }
            ],
            bookingSupportDialog:false,
            booking:{},
            query:null,
            ticket_dialog:false,
            refundModificationDialog:false,
        }
    },
    components:{BookingSupport,VueQrcode,TicketsDialog,RefundModification},
    created(){
        this.listBookings();
    },
    computed: {
        ...mapGetters("company", {
        currentCompanyId: "getCurrentCompanyId"
        }),
    },
    mixins:[currencySymbol],
    methods:{
        _seatLabels(seatLabelObjs={}){
            var seats = Object.values(seatLabelObjs);
            if(seats.length){
                return seats.map(seat => seat.label).join(", ");
            }
        },
        _venue(venue){
            if(!venue){
                return;
            }
            return venue.name+", "+venue.address;
        },
        async listBookings(){
            try {
                this.loader = true;
                let response =  await this.$store.dispatch("consumer/listPhysicalEventBookings",{
                    company_id : this.currentCompanyId
                });
                this.bookings = response.bookings;
            } catch (error) {
                this.$store.dispatch("app/showMessage", {
                    message: error.message,
                    color: "error"
                });
            }finally{
                this.loader = false;
            }
        },
        viewReceipt(booking) {
            if (!booking.purchase_receipt_url) {
                return;
            }
            window.open(booking.purchase_receipt_url);
        },

        showBookingSupportDialog(booking){
            this.booking = booking;
            this.bookingSupportDialog = true;
        },
        resetBookingSupportDialog(){
            this.bookingSupportDialog = false;
            this.booking = {};
            this.query = null;
        },
        async submitBookingQuery(){
            try {
                await this.$store.dispatch('bookings/submitBookingQuery',{
                    booking_id: this.booking.id,
                    screener_id: this.booking.screener_id,
                    query: this.query
                });
                await this.$store.dispatch("app/showMessage", {
                    message: 'Your request has been submited to admin',
                    color: "success"
                });
            } catch (error) {
                this.$store.dispatch("app/showMessage", {
                    message: error.message,
                    color: "error"
                });
            } finally{
                this.resetBookingSupportDialog();
            }
        },
        previewTickets(booking) {
            this.booking = booking;
            this.ticket_dialog= true;
        },

        showRefundRequestDialog(booking) {
            if (!booking.purchase_receipt_url) {
                return;
            }
            this.booking = booking;
            this.refundModificationDialog = true;
        },

        resetRequestFormParam() {
            this.booking = null;
            this.refundModificationDialog = false;
        }
    }
}
</script>

<style scoped>
.border-round{
   border: 1.5px solid #bdbdbd;
   border-radius: 10px;
}
</style>
